import React from "react";
// External Dependencies
import classNames from "classnames";
// Internal Dependencies
import { VscHome } from "react-icons/vsc";
import { SubHeaderTitleCss } from "./SubHeaderTitle.styled";

// Define prop types
interface SubHeaderTitleProps {
  subTitle: string;
  className?: string;
  ulClassName?: string;
  liClassName?: string;
  linkClassName?: string;
  listArray?: Array<Record<string, string>>;
}

const SubHeaderTitle: React.FC<SubHeaderTitleProps> = ({
  subTitle,
  className,
  ulClassName,
  liClassName,
  linkClassName,
  listArray,
}) => {
  // Combining default and additional classes for the main classes
  const mainClasses = classNames(
    "m-subheader__title m-subheader__title--separator",
    className
  );
  // Combining default and additional classes for the ul classes
  const ulClassess = classNames(
    "m-subheader__breadcrumbs m-nav m-nav--inline",
    ulClassName
  );
  // Combining default and additional classes for the li classes
  const liClassess = classNames("m-nav__item m-nav__item--home", liClassName);
  // Combining default and additional classes for the link classes
  const linkClassess = classNames(
    "m-nav__link m-nav__link--icon",
    linkClassName
  );

  return (
    <SubHeaderTitleCss>
      <a
        href="/dashboard"
        className={`common__linkTags ${linkClassess}`}
        style={{ fontSize: "22px" }}
      >
        <VscHome style={{ fontSize: "2rem" }} />
      </a>
      <span className="common__span__code" style={{ fontSize: "13px" }}>|</span>
      <h3
      style={{ border: "none", fontSize: "16px" ,paddingTop: "4px"}}
        className={`common__subtitle ${mainClasses}`}
      >
        {subTitle}
      </h3>
      <ul className={ulClassess}>
        <li className={liClassess}></li>
        {listArray?.map((item, index) =>
          // Assuming there's only one key in each object
          Object.keys(item).map((key, keyIndex) => (
            <li
              key={`${index}-${keyIndex}`}
              className="m-nav__item m-nav__item--home pt-2"
            >
              {key}: {item[key]}
            </li>
          ))
        )}
      </ul>
    </SubHeaderTitleCss>
  );
};

export default SubHeaderTitle;
